<!--
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-07-20 09:36:17
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-08-23 17:08:31
 * @FilePath: /genetron-web/genetron-h5/src/components/template/reportIndex825/hlywTips copy.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!--
 * @Author: caoyingming 1046659469@qq.com
 * @Date: 2022-07-15 10:07:33
 * @LastEditors: caoyingming 1046659469@qq.com
 * @LastEditTime: 2022-07-15 10:07:33
 * @FilePath: /genetron-web/genetron-h5/src/components/template/reportIndex825/hlywTips.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="hl-info" @click="detail('geneVariation')">
    <label for=""> 肿瘤发生发展相关基因变异（临床意义不明）III类</label>
    <i class="iconfont icon-right_medium"></i>
  </div>
</template>
<script>
import isiOS from "@/utils/iosAn";
export default {
  props: {
    isShowData: {
      type: String,
    },
    templateId: {
      type: String,
    },
  },
  data() {
    return {
      inAnimation: false,
    };
  },
  methods: {
    detail(name) {
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url: "/packageWebView/pages/chemotherapy/chemotherapy",
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({ name: name });
      } else {
        window.android.JSCallNative(JSON.stringify({ name: name, type: "" }));
      }
      // geneVariation
    },
  },
};
</script>
<style lang="less" scoped>
@keyframes bgSize {
  from {
    background: rgba(0, 0, 0, 0)
  }
  to {
    background: rgba(0, 0, 0, 0.05)
  }
}

.newColor {
  animation: bgSize 0.5s ease-in
  // background: rgba(0, 0, 0, 0.05) !important;
}
.hl-info {
  height: 70px;
  font-size: 18PX;
  padding: 0 24px;
  font-weight: 500;
  color: #2f354d;
  line-height: 70px;
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  label{
    width: 90%;
    overflow: hidden;
    display: inline-block;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  i {
    float: right;
  }
}
.hl-info:active{
  background: rgba(0, 0, 0, 0.05);
  transition: background 0.6s;
}
</style>
